import { Stack } from '@hotjar/hotsauce';

import type { SiteAccount, OwnedAccount } from '@hotjar/account';
import type {
  ProductCatalog,
  AnalyticsProduct,
  FeedbackProduct,
} from '@hotjar/webapp/domains/common/product/types';
import { ProductType } from '@hotjar/webapp/domains/common/product/types';

import { SkuDropdown } from './SkuDropdown';

export interface MultiSkuDropdownProps {
  siteAccount: SiteAccount | OwnedAccount;
  productCatalog?: ProductCatalog;
  onChange: (params: AnalyticsProduct | FeedbackProduct) => void;
  hidePlanBadges?: boolean;
  activeFeedbackProductSku?: string;
  activeAnalyticsProductSku?: string;
  isTwoSkusActionRequired?: boolean;
}

export const MultiSkuDropdown = ({
  siteAccount,
  productCatalog,
  onChange,
  hidePlanBadges,
  activeFeedbackProductSku,
  activeAnalyticsProductSku,
  isTwoSkusActionRequired,
}: MultiSkuDropdownProps): JSX.Element | null => {
  if (!productCatalog) return null;

  type ProductTypes = keyof ProductCatalog;

  return (
    <Stack direction="column" spacing="x2pt5">
      {(Object.keys(productCatalog) as Array<ProductTypes>).sort().map((productType) => {
        const products = productCatalog[productType];
        const activeProduct =
          (products as Array<FeedbackProduct | AnalyticsProduct>).find((product) =>
            product.type === ProductType.Analytics
              ? product.sku === activeAnalyticsProductSku
              : product.sku === activeFeedbackProductSku,
          ) ?? products[0];

        const selfServeProducts = (products as Array<FeedbackProduct | AnalyticsProduct>).filter(
          (product) => product.selfServeEnabled,
        );

        return (
          <SkuDropdown
            key={productType}
            onChange={onChange}
            hidePlanBadges={hidePlanBadges}
            productType={productType}
            activeProduct={activeProduct}
            products={selfServeProducts}
            isTwoSkusActionRequired={isTwoSkusActionRequired}
            siteAccount={siteAccount}
          />
        );
      })}
    </Stack>
  );
};
